import React from 'react';
import { connect } from 'react-redux';

import find from 'lodash/find';

function Campaign({ campaignId, popupCampaigns }) {
	const campaign = find(popupCampaigns, { id: campaignId });
	return (
		<li>{campaign.text}</li>
	);
}

function mapStateToProps(state) {
	return {
		popupCampaigns: state.root.lists['popup-campaigns']
	};
}

export default connect(mapStateToProps)(Campaign);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/popup/list/components/campaign.js